// EXT-6658: drop-in for @angular/fire/performance.
import { isPlatformBrowser } from '@angular/common';
import { InjectionToken, PLATFORM_ID, inject } from '@angular/core';
import { FirebasePerformance } from 'firebase/performance';
import { InitFn, provideInstance } from '@jfw/angular/shared/firebase';
import { FirebaseApp } from '@jfw/angular/shared/firebase/app';

export * from 'firebase/performance';

/**
 * Null on the server. The SDK throws "Window is not available" during SSR,
 * so Performance is browser-only, as in AngularFire (the EXT-5098 POC's
 * first version crashed the prerender without this).
 */
export const Performance = new InjectionToken<FirebasePerformance>(
  'jfw.firebase.performance',
);
export type Performance = FirebasePerformance;

export const providePerformance = (fn: InitFn<FirebasePerformance>) =>
  provideInstance(
    Performance,
    (injector) =>
      isPlatformBrowser(injector.get(PLATFORM_ID))
        ? fn(injector)
        : (null as unknown as FirebasePerformance),
    () => inject(FirebaseApp),
  );
